import SingleInputForm from '../../elements/SingleInputForm/SingleInputForm'
import css from './GameCreation.module.css'
import Guide from '../../elements/Guide/Guide'
import Heading from '../../elements/Heading/Heading'
import i18next from 'i18next'

function GameCreation(props) {
  const { humanId, callback } = props

  async function createGame(humanAlias) {
    const url = `${process.env.REACT_APP_API_URL}/game`
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ human: { id: humanId, alias: humanAlias } }),
    })
    return await response.json()
  }

  function handleSubmit(humanAlias) {
    // attempt game creation
    createGame(humanAlias)
      .then(({ data }) => {
        window.localStorage.setItem('gameId', data.id)
        callback(data)
      })
      .catch(() => {
        callback(null)
      })
  }

  return (
    <div className={css.GameCreation}>
      <Heading text={i18next.t('gameCreation.heading.title')} />
      <Guide text={i18next.t('gameCreation.guide.main')} />
      <SingleInputForm
        label={i18next.t('gameCreation.input.name.label')}
        placeholder={i18next.t('gameCreation.input.name.placeholder')}
        buttonText={i18next.t('gameCreation.button.cta.enabled')}
        buttonTextDisabled={i18next.t('gameCreation.button.cta.disabled')}
        callback={handleSubmit}
      />
    </div>
  )
}

// TODO: Rename to initialization
export default GameCreation
